import { InterferenceResultView } from '../InterferenceResultView/InterferenceResultView';
import { GenericResultView } from '../GenericResultView/GenericResultView';

const RESULT_VIEWS = {
    interference: InterferenceResultView,
};

export const RuleResultView = ({ ruleKind, result }) => {
    if (!result) return '-';
    const View = RESULT_VIEWS[ruleKind] ?? GenericResultView;
    return <View result={result} />;
};

export default RuleResultView;
